"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVAILABLE_PER_DIEM_YEARS = exports.PER_DIEM_2025 = exports.PER_DIEM_2024 = exports.PER_DIEM_2023 = exports.PER_DIEM_2022 = void 0;
exports.PER_DIEM_2022 = 2022;
exports.PER_DIEM_2023 = 2023;
exports.PER_DIEM_2024 = 2024;
exports.PER_DIEM_2025 = 2025;
exports.AVAILABLE_PER_DIEM_YEARS = [exports.PER_DIEM_2022, exports.PER_DIEM_2023, exports.PER_DIEM_2024, exports.PER_DIEM_2025];
